import react from "react";

function SomethingWentWrong(props) {
  return (
    <div className="error">
      <p> Something went wrong!</p>
      <p>
        Please contact <span>Appolin S. Fotso</span>
      </p>
    </div>
  );
}

export default SomethingWentWrong;
